import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import EventMore from '../Event/EventMore';
import Map from '../Home/Map';

const PageNotFound = () => {
  const dictionary = useSelector((state) => state.dictionaryReducer.dictionary);
  const navigate = useNavigate();

  return (
    <section className="section">
      <div className="container">
        <div className="row">
          <div className="col-lg-9">
            <div className="page_not_found">
              <h1><b>{dictionary.page_not_found.title}</b></h1>
              <br />
              <span>
                {dictionary.page_not_found.first_part}
                {' '}
                <a
                  href="/"
                  onClick={(e) => {
                    e.preventDefault();
                    navigate('/');
                  }}
                >
                  {dictionary.page_not_found.here}
                </a>
                {' '}
                {dictionary.page_not_found.second_part}
                .
              </span>
            </div>
          </div>
          <div className="col-lg-3 pl-lg-4 d-none mt-3 d-lg-block">
            <div className="saidbar">
              <div className="saidbar-content">
                <EventMore />
              </div>
            </div>
          </div>
          <Map />
        </div>
      </div>
    </section>
  );
};

export default PageNotFound;
